import { Box, Button, InputAdornment, TextField } from "@mui/material";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SearchBar from "../../components/SearchBar";
import { showError, showToast } from "../../helpers/showToast";
import ApprovedIndividualsList from "../../features/individuals/ApprovedIndividualsList";
import MainContainer from "../../layout/MainContainer";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { isValidInput } from "../../utils/validations";
import DatePicker from "Modals/datePicker";
import {
  useChangeUserStatusMutation,
  useLazyExportCsvQuery,
  useLazyGetAllUsersQuery,
} from "service/user";
import { generateEncryptedKeyBody } from "utils/crypto";
import { CommonBody } from "types/General";
import { UPDATE_TYPES } from "utils/enums";
import dayjs, { Dayjs } from "dayjs";
import { ClearIcon } from "@mui/x-date-pickers";
import { useLazyDeleteUserQuery } from "service/auth";
import CustomPagination from "components/Panigation";

const ManageUsers = () => {
  const [getUsers] = useLazyGetAllUsersQuery();
  const [changeStatus] = useChangeUserStatusMutation();
  const [exportCsv] = useLazyExportCsvQuery();
  const [deleteUser] = useLazyDeleteUserQuery();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleUserUpdate = async (id: string, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { isBlocked: status } : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await changeStatus({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = users?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              isBlocked: status,
            };
          }
          return item;
        });
        setUsers(updatedData);
        if (status === true) {
          showToast("Blocked successfully");
        } else {
          showToast("Unblocked successfully");
        }
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const getUsersApi = async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        page: page,
        search: debouncedSearchTerm,
        startDate: startDate?.format("YYYY-MM-DD"),
        endDate: endDate?.format("YYYY-MM-DD"),
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setUsers(response?.data?.list);
        setCount(response?.data?.totalCount);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const exportCsvApi = async () => {
    setLoading(true);
    try {
      const response = await exportCsv({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        window.open(response?.data, "_blank");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const deleteUserApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteUser({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        getUsersApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsersApi();
  }, [page, debouncedSearchTerm, startDate, endDate]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Individuals</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Registrations - Individuals
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search individuals"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>

              <Box className="search_box">
                <Box className="search_bar">
                  <TextField
                    value={
                      startDate && endDate
                        ? `${startDate?.format("YYYY-MM-DD")}- ${endDate?.format("YYYY-MM-DD")}`
                        : ""
                    }
                    // onChange={onChange}

                    hiddenLabel
                    placeholder={"Select date"}
                    inputProps={{ readOnly: true }}
                    className="txt_inpt"
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="end"
                          className="search_icon"
                          onClick={() => setOpenDate(true)}
                          sx={{ cursor: "pointer" }}
                        >
                          <CalendarTodayIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end" className="cross_btn">
                          {startDate && endDate ? (
                            <ClearIcon
                              style={{
                                background: "white",
                                color: "red",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setStartDate(null);
                                setEndDate(null);
                              }}
                            />
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_highlight" onClick={exportCsvApi}>
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <ApprovedIndividualsList
            count={count}
            rows={users}
            page={page}
            onPageChange={handlePageChange}
            loading={loading}
            setUsers={setUsers}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            handleDeleteUser={() => {}}
            handleUserUpdate={handleUserUpdate}
            setModalType={setModalType}
            setOpen={setOpen}
          />
          {users?.length ? (
            <CustomPagination
              currentPage={page - 1}
              totalPages={Math.ceil(count / 10)}
              count={count}
              pageSize={10}
              onPageChange={(page) => setPage(page + 1)}
            />
          ) : null}
        </Box>
      </div>
      <ConfirmationModal
        text={
          modalType === "delete"
            ? "Are you sure to delete this individual?"
            : modalType === "accept"
              ? "Are you sure to approve this individual?"
              : modalType === "reject"
                ? "Are you sure to reject this individual?"
                : ""
        }
        openModal={open}
        setOpenModal={setOpen}
        handleSubmit={() => {
          deleteUserApi(selectedId);
          setOpen(false);
        }}
      />
      <DatePicker
        open={openDate}
        setOpen={setOpenDate}
        onClose={() => {
          setOpenDate(false);
        }}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        onSubmit={() => {
          getUsersApi();
          setOpenDate(false);
        }}
      />
    </MainContainer>
  );
};

export default ManageUsers;
